import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getRelatedBlog from "./getRelatedBlog";

const initialState = {
  isLoading: false,
  error: "",
  relatedBlogs: [],
};
export const fetchRelatedBlogs = createAsyncThunk(
  "relatedBlogs/fetchRelatedBlogs",
  async ({ tags, id }) => {
    const relatedBlog = await getRelatedBlog({ tags, id });
    return relatedBlog;
  }
);

const relatedBlogsSlice = createSlice({
  name: "relatedBlogs",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedBlogs.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchRelatedBlogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = "";
        state.relatedBlogs = action.payload;
      })
      .addCase(fetchRelatedBlogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default relatedBlogsSlice.reducer;
